/* beautiful-react-hooks version: 0.35.0 */
import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.js';
import useSwipe from './useSwipe.js';

var defaultOptions = {
  threshold: 15,
  preventDefault: true
};

var useHorizontalSwipe = function useHorizontalSwipe() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;

  var opts = _objectSpread2(_objectSpread2(_objectSpread2({}, defaultOptions), options || {}), {
    direction: 'horizontal'
  });

  return useSwipe(ref, opts);
};

export default useHorizontalSwipe;
